exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover.tag_popover{padding:0;min-width:20px;background:-webkit-gradient(linear,left top,left bottom,from(rgba(17,52,68,.8)),to(rgba(9,127,164,.8)));background:linear-gradient(rgba(17,52,68,.8),rgba(9,127,164,.8));background-color:#d0efff;border:none;border-radius:32px}.el-popover.tag_popover[x-placement^=top] .popper__arrow,.el-popover.tag_popover[x-placement^=top] .popper__arrow:after{border-top-color:rgba(9,127,164,.8)}", ""]);

// exports
